// 常量
export const priceReg = /^(0|[1-9]\d*|[1-9]\d*\.\d{1,2}|0\.\d{1,2})$/;

// 付款账务科目
export enum SubjectCodeType {
  OTA_ROOM_FEE = 'D01010002', // 酒店OTA房费预付
  OTA_ZL_ROOM_FEE = 'D01010004', // 酒店OTA直连房费预付
  CRS_ROOM_FEE = 'D01010003', // 酒店CRS房费预付
}

// 是否展示渠道计算器入口
// 付款账务项目为：OTA预付款、OTA直连预付款、CRS预付款
// 支付渠道为：美团、携程、抖音、中央预订等（可直接以上述账目项目为准）
export const isShowCalculator = (subjectCode: any) => {
  const fitCode = [
    SubjectCodeType.OTA_ROOM_FEE,
    SubjectCodeType.OTA_ZL_ROOM_FEE,
    SubjectCodeType.CRS_ROOM_FEE,
  ];
  if (fitCode.includes(subjectCode)) return true;
  return false;
};
